import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

export default function Breadcrumb(props) {
  const classes = useStyles();
  const breadcrumbColor = 'var(--hrms-primary-blue-end, #036dda)';

  return (
    <div className={`${classes.root} common-breadcrumb`.trim()}>
      <Breadcrumbs
        separator={
          <NavigateNextIcon
            fontSize="small"
            className="common-breadcrumb-separator"
            style={{ color: breadcrumbColor }}
          />
        }
        aria-label="breadcrumb"
      >
        <Link
          className="common-breadcrumb-link"
          color="inherit"
          style={{ color: breadcrumbColor, fontWeight: 600 }}
          onClick={(e) => { props.history.push('/dashboard') }}
        >
          CSPI-EMS
        </Link>
        <Link
          className="common-breadcrumb-link"
          color="inherit"
          style={{ color: breadcrumbColor, fontWeight: 600 }}
          onClick={(e) => { props.history.push(props.primaryPageLink) }}
        >
          {props.primaryPageName}
        </Link>
        {(props.isSecondaryPage) ? (
          <Typography
            color="textPrimary"
            className="common-breadcrumb-current"
            style={{ color: breadcrumbColor, fontWeight: 600 }}
          >
            {props.secondaryPageName}
          </Typography>
        ) : ""}
      </Breadcrumbs>
    </div>
  );
}
